import React from "react";
import { Helmet } from "react-helmet-async";

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  image?: string;
  url?: string;
  type?: string;
  author?: string;
  publishedTime?: string;
  modifiedTime?: string;
  section?: string;
  tags?: string[];
  noindex?: boolean;
}

const SEO: React.FC<SEOProps> = ({
  title = "DappGenius - Fractional CTO for Blockchain Teams",
  description = "Fractional CTO for blockchain teams. Expert smart contract development, DeFi integrations. $15M+ secured.",
  keywords = "blockchain development, smart contracts, Web3, DeFi, NFT, Ethereum, Solidity, token launch, fractional CTO",
  image = "https://dappgenius.xyz/img/jan.png",
  url = "https://dappgenius.xyz/",
  type = "website",
  author = "Jan Kwiatkowski - DappGenius",
  publishedTime,
  modifiedTime,
  section,
  tags,
  noindex = false,
}) => {
  const siteUrl = "https://dappgenius.xyz";
  const fullUrl = url.startsWith("http") ? url : `${siteUrl}${url}`;
  const fullImage = image.startsWith("http") ? image : `${siteUrl}/${image}`;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content={author} />
      <link rel="canonical" href={fullUrl} />

      {noindex && <meta name="robots" content="noindex,nofollow" />}

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullImage} />
      <meta property="og:site_name" content="DappGenius" />

      {publishedTime && (
        <meta property="article:published_time" content={publishedTime} />
      )}
      {modifiedTime && (
        <meta property="article:modified_time" content={modifiedTime} />
      )}
      {author && <meta property="article:author" content={author} />}
      {section && <meta property="article:section" content={section} />}
      {tags &&
        tags.map((tag) => (
          <meta key={tag} property="article:tag" content={tag} />
        ))}

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={fullUrl} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullImage} />
      <meta name="twitter:creator" content="@dappgenius" />

      {/* Additional SEO */}
      <meta name="theme-color" content="#2563eb" />
    </Helmet>
  );
};

export default SEO;
